import { Form, Checkbox } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

const FormulaStyleField: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Form.Item name={['style', 'fontWeight']} valuePropName="checked" label={t('global:style')}>
      <Checkbox>{t('formulaPage:bold')}</Checkbox>
    </Form.Item>
  )
}

export default FormulaStyleField
